var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6471 11.1364C17.1371 11.1364 14.2941 13.9841 14.2941 17.5C14.2941 21.0159 17.1371 23.8636 20.6471 23.8636C24.1571 23.8636 27 21.0159 27 17.5C27 13.9841 24.1571 11.1364 20.6471 11.1364ZM16.6765 17.5C16.6765 15.3045 18.4553 13.5227 20.6471 13.5227C21.3141 13.5227 21.9176 13.6977 22.4735 13.9841L17.1371 19.3295C16.8512 18.7727 16.6765 18.1682 16.6765 17.5ZM20.6471 21.4773C19.98 21.4773 19.3765 21.3023 18.8206 21.0159L24.1571 15.6705C24.4429 16.2273 24.6176 16.8318 24.6176 17.5C24.6176 19.6955 22.8388 21.4773 20.6471 21.4773ZM19.0588 27.0455H3.17647V7.95455H19.0588V9.54545H22.2353V3.18182C22.2353 1.43182 20.8059 0 19.0588 0H3.17647C1.42941 0 0 1.43182 0 3.18182V31.8182C0 33.5682 1.42941 35 3.17647 35H19.0588C20.8059 35 22.2353 33.5682 22.2353 31.8182V25.4545H19.0588V27.0455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlock);
export default __webpack_public_path__ + "static/media/phone-block.3f4e2d8db34a3edfe422c01d0fad477a.svg";
export { ForwardRef as ReactComponent };